<template>
    <div class="checkbox-group">
        <check-list
            v-model="subjectivityTypes"
            label="Subjectivities?"
            item-value="name"
            :item-rules="[
                ruleRequired,
                v => Boolean(v.replace(/ /g, '')) || 'Required',
                v => Boolean(v.length <= 255) || 'Subjectivities must be less than 255 characters'
            ]"
            item-hide-details
            addition-text="Add subjectivity"
        />
    </div>
</template>

<script>
    import CheckList from '~/components/Shared/UIComponents/CheckList';
    import rules from '~/mixins/rules';

    export default {
        name: 'AddEditSubjectivities',
        components: {
            CheckList
        },
        mixins: [rules],
        props: ['value'],
        data() {
            return {
                subjectivityTypes: [
                    {
                        name: 'Satisfactory review of underlying documentation',
                        editable: false,
                        selected: false
                    },
                    {
                        name: 'Capacity being available at the time of binding',
                        editable: false,
                        selected: false
                    },
                    {
                        name: 'No material adverse change',
                        editable: false,
                        selected: false
                    },
                    {
                        name: 'Details of prior experience',
                        editable: false,
                        selected: false
                    }
                ]
            }
        },
        computed: {
            subjectivities: {
                get() {
                    return this.value || []
                },
                set(selectedSubjectivities) {
                    this.$emit('input', selectedSubjectivities);
                }
            },
        },
        watch: {
            subjectivities: {
                handler(newVal) {
                    const subjectivities = this.subjectivityTypes.map(s => s.name);

                    newVal.forEach(subjectivity => {
                        if (subjectivities.includes(subjectivity)) {
                            this.subjectivityTypes.find(subjectivityType => subjectivityType.name === subjectivity).selected = true;
                        } else {
                            this.subjectivityTypes.push(
                                {
                                    name: subjectivity,
                                    editable: true,
                                    selected: true
                                }
                            );
                        }
                    });
                },
                deep: true,
                immediate: true,
            },
            subjectivityTypes: {
                handler(newVal) {
                    this.subjectivities = newVal.filter(s => s.selected === true).map(s => s.name);
                },
                deep: true,
            },
        }
    }
</script>
